// extracted by mini-css-extract-plugin
export default {"previewImage":"Loader_previewImage__aU0N8","spinner":"Loader_spinner__TsjL6"};